<template>
  <div class="menu-detail">
    <!-- 基础信息部分 -->
    <headline title="基本信息" class="headline" />
    <el-divider class="base-divider" />
    <el-table class="zwx-table zwx-table-detail" style="width: 100%;" row-key="key" :data="dataList" :show-header="false" border :stripe="false">
      <el-table-column prop="key" width="100" header-align="right" align="right"></el-table-column>
      <el-table-column prop="value" header-align="left" align="left"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'MenuDetail',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      menuTypes: ['目录', '内部菜单', '外部菜单'],
      dataList: [],
    }
  },
  created() {},
  mounted() {
    this.detail()
  },
  computed: {},
  methods: {
    detail() {
      this.$emit('loading', true)
      let data = {
        rid: this.rid,
      }
      this.$system.get(this.api + '/systematic/getMenu-1', data, true, true, this.detailSuccess, this.error)
    },
    detailSuccess(data) {
      if (data.type === '00') {
        this.dataList.push({ key: '菜单编号：', value: data.menu.menuNotice })
        this.dataList.push({ key: '菜单标题：', value: data.menu.menuTitle })
        this.dataList.push({ key: '菜单编码：', value: data.menu.menuCode })
        this.dataList.push({ key: '菜单图标：', value: data.menu.menuIcon })
        this.dataList.push({ key: '菜单子图标：', value: data.menu.menuChildIcon })
        this.dataList.push({ key: '菜单类别：', value: this.menuTypes[data.menu.menuType] })
        if (data.menu.menuType !== 0) this.dataList.push({ key: '菜单URL：', value: data.menu.menuUrl })
        this.$emit('loading', false)
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
